import React, { useEffect } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  headerAction?: React.ReactNode;
  children: React.ReactNode;
  size?: "md" | "lg" | "xl";
}

const sizeClass = { md: "md:max-w-lg", lg: "md:max-w-2xl", xl: "md:max-w-3xl" };

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, headerAction, children, size = "md" }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center">
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />
      <div className={`relative bg-white rounded-t-2xl md:rounded-xl shadow-xl w-full ${sizeClass[size]} md:mx-4 max-h-[85vh] md:max-h-[90vh] overflow-y-auto`}>
        {title && (
          <div className="flex items-center justify-between p-4 border-b border-gray-200 sticky top-0 bg-white z-10 gap-3">
            <h2 className="text-lg font-semibold text-gray-900 truncate min-w-0">{title}</h2>
            <div className="flex items-center gap-2 shrink-0">
              {headerAction}
              <button onClick={onClose} className="p-2 -mr-2 text-gray-400 hover:text-gray-600 active:text-gray-800 rounded-full">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        )}
        <div className="p-4 pb-6 md:pb-4">{children}</div>
      </div>
    </div>
  );
};
